import React from 'react';
import { Col, Button } from 'antd';
import PropTypes from 'prop-types';

export default function FormActionButtonBaoCao(props) {
  const {
    goBack,
    handleSubmit, loadingButton,
    handleExportExcel,
    handleRedirectEdit,
    handleCancle,
    actions
  } = props;
  const {
    duyet, loadingButtonDuyet, traLai, edit
  } = actions;
  return (
    <Col className="footer-form" span={24}>
      {goBack && (
        <Button
          icon="left"
          onClick={goBack}
        >
          Quay lại
        </Button>
      )}
      {handleCancle && (
        <Button
          icon="close-circle"
          onClick={handleCancle}
        >
          Hủy
        </Button>
      )}
      {handleSubmit && (
        <Button
          icon="save"
          loading={loadingButton}
          onClick={handleSubmit}
          type="primary submit"
        >
          Cập nhật
        </Button>
      )}
      {handleExportExcel && (
        <Button
          className="qti-default-button heading-button-export-excel"
          icon="file-excel"
          onClick={handleExportExcel}
        >
          Xuất excel
        </Button>
      )}
      {handleRedirectEdit && (
        <Button
          icon="edit"
          onClick={handleRedirectEdit}
          style={{ background: 'green', color: '#fff' }}
        >
          Chỉnh sửa
        </Button>
      )}
      {duyet && (
        <Button
          className="qti-default-button heading-button-export-excel"
          icon="check"
          loading={loadingButtonDuyet}
          onClick={duyet}
        >
          Duyệt
        </Button>
      )}
      {traLai && (
        <Button
          icon="rollback"
          onClick={traLai}
          type="danger"
        >
          Trả lại
        </Button>
      )}
      {edit && (
        <Button
          icon="edit"
          onClick={edit}
          type="primary"
        >
          Chỉnh sửa
        </Button>
      )}
    </Col>
  );
}

FormActionButtonBaoCao.propTypes = {
  handleSubmit: PropTypes.func,
  goBack: PropTypes.func,
  handleExportExcel: PropTypes.func,
  handleRedirectEdit: PropTypes.func,
  handleCancle: PropTypes.func,
  loadingButton: PropTypes.bool,
  actions: PropTypes.shape({
    duyet: PropTypes.func,
    loadingButtonDuyet: PropTypes.bool,
    traLai: PropTypes.func,
    edit: PropTypes.func
  })
};

FormActionButtonBaoCao.defaultProps = {
  handleSubmit: null,
  goBack: null,
  handleExportExcel: null,
  handleRedirectEdit: null,
  handleCancle: null,
  loadingButton: false,
  actions: {
    duyet: null,
    loadingButtonDuyet: false,
    traLai: null,
    edit: null
  }
};
